import { render, staticRenderFns } from "./ConfirmDomain.vue?vue&type=template&id=4b6682dc&scoped=true"
import script from "./ConfirmDomain.vue?vue&type=script&lang=js"
export * from "./ConfirmDomain.vue?vue&type=script&lang=js"
import style0 from "./ConfirmDomain.vue?vue&type=style&index=0&id=4b6682dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6682dc",
  null
  
)

export default component.exports